import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Storefront.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(n, { ref: e, ...t, weights: a }));
r.displayName = "StorefrontIcon";
const c = r;
export {
  c as Storefront,
  r as StorefrontIcon
};
